
export class WithDrawalsViewModel {

  public Id: string;
  public withDrawalID: number;
  public requestBy: number;
  public totalAmmount: number;
  public requestDate: Date;
  public statusId: number;
  public adminComments: string;
  public statusName: string;

}



// WEBPACK FOOTER //
// ./src/app/models/Withdrawals/withdrawals-view.ts